import React, { useEffect, useState } from 'react'
import { useFormContext, useFieldArray } from 'react-hook-form'
import { TextInput, BooleanInput, SelectInput, useTranslate, useNotify, required } from 'react-admin'
import { EditInputsWrap } from 'src/components/uiElements/CRUD/EditInputsWrap'
import { applicationServices } from 'src/services/auth/application/application.service'
import { Delete, Add } from '@mui/icons-material'
import Button from '@mui/material/Button'
import { Skeleton } from '@mui/material'
import { isJsonValidate } from 'src/helper/validatorJson'

export const FieldArray = () => {
  const translate = useTranslate()
  const notify = useNotify()
  const { control } = useFormContext()
  const [optionsApplication, setOptionsApplication] = useState([])
  const [loading, setLoading] = useState(false)
  const { fields, append, remove } = useFieldArray({
    control, // control props comes from useForm (optional: if you are using FormContext)
    name: 'applicationByClient', // unique name for your Field Array
  })

  const getAllApplications = async () => {
    setLoading(true)
    try {
      const allApplications = await applicationServices.getByAll()
      if (allApplications) {
        setOptionsApplication(allApplications)
        setLoading(false)
        return
      }
      setOptionsApplication([])
      notify(`applications not found`, { type: 'error' })
      setLoading(false)
    } catch (error) {
      setOptionsApplication([])
      notify(`please, refresh page`, { type: 'error' })
      setLoading(false)
    }
  }

  useEffect(() => {
    ;(async () => {
      await getAllApplications()
    })()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <>
      {React.Children.toArray(
        fields.map((field, index) => (
          <div
            key={field.id}
            style={{
              width: '100%',
              height: 'auto',
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
              alignItems: 'center',
            }}
          >
            <div style={{ width: '100%', height: 'auto', display: 'flex', justifyContent: 'space-between' }}>
              <EditInputsWrap label={translate('ra.field.application')} required>
                {loading ? (
                  <Skeleton variant='rectangular' width={300} height={40} />
                ) : (
                  <SelectInput
                    source={`applicationByClient.${index}.application_id`}
                    optionText='long_name'
                    sx={{ width: 300 }}
                    choices={optionsApplication}
                    label=''
                    validate={[required()]}
                  />
                )}
              </EditInputsWrap>
              <EditInputsWrap label={translate('ra.field.config')}>
                <TextInput
                  sx={{ width: 300 }}
                  source={`applicationByClient.${index}.config`}
                  label=''
                  fullWidth
                  validate={isJsonValidate}
                  format={(v) => {
                    return JSON.stringify(v ? v : undefined)
                  }}
                  parse={(v) => {
                    try {
                      if (v.length >= 2) {
                        return JSON.parse(v)
                      }
                    } catch (e) {
                      notify('ra.field.invalid_json', { type: 'error' })
                      return undefined
                    }
                  }}
                />
              </EditInputsWrap>
              <EditInputsWrap label={translate('ra.field.is_active')}>
                <BooleanInput
                  label={translate('ra.field.is_active')}
                  source={`applicationByClient.${index}.is_active`}
                  fullWidth
                />
              </EditInputsWrap>
              <Button onClick={() => remove(index)} startIcon={<Delete />} color='error'>
                {translate('ra.action.delete')}
              </Button>
            </div>
          </div>
        ))
      )}
      <Button
        startIcon={<Add />}
        onClick={() => {
          append()
        }}
      >
        {translate('ra.action.add_specific', {
          name: translate('ra.field.applications'),
        })}
      </Button>
    </>
  )
}
